import { DashboardElement } from '../../../models/chart.models';
import { FilterBoxConfig, FilterElement } from '@nx-fe/filter';
import { DashboardElementParam } from 'core/services/dataRequest';
import { FilterDateSelectionType, IDateRange } from '@nx-fe/date-picker';
import { McGroup } from '../profiles/profiles.models';

export interface PageCascadingFilter {
  filterIdx: string;
  filterType: string;
  timestamp: number;
  tag?: {
    filterValue: any;
    filterLabel: string;
  };
  cascade?: {
    type: CascadeType;
    value?: any;
    name?: string;
  };
}

export enum CascadeType {
  VALUE_FILTER = 'value filter',
  NAME_FILTER = 'name filter',
}

export interface SharedFilter {
  selectedDateFilter?: IDateFilterSelection;
}

export interface GlobalFilter {
  appFilters: {
    [dashboardType: string]: GlobalAppFilter;
  };
  pageFilters: { [pageBaseline: string]: GlobalPageFilter };
  sharedFilters: SharedFilter;
}

export interface GlobalDashboardFilter {
  filterBarExpression?: FilterBarExpression;
  shiftId?: number;
}

export interface GlobalPageFilter {
  predefinedCharts: PredefinedCharts[];
}

export interface GlobalAppFilter {
  dashboardFilters: {
    [pageCategory: string]: GlobalDashboardFilter;
  };
  groupIds?: number[];
  stores?: string[];
}

export class UtilizationStores {
  StoreId: number;
  StoreName: string;
}

export interface PageConfig {
  id: string;
  applicationType: string[];
  attributes: string[];
  baselineId?: string;
  chartIds: string[];
  cascadingFilterOn: boolean;
  cascadingFilters: {
    [filterIdx: string]: PageCascadingFilter;
  };
  shiftId?: number;
  shiftEnabled?: boolean;
  dateFilterTypes?: FilterDateSelectionType[];
  filterBarConfig?: FilterBoxConfig;
  filterBarExpression?: FilterBarExpression;
  filterBarVisible?: boolean;
  isDirty?: boolean;
  name: string;
  icon?: string;
  predefinedCharts?: PredefinedCharts[];
  selectedDateFilter?: IDateFilterSelection;
  mcGroups?: McGroup[];
  selectedMcGroup?: number[];
  stores?: UtilizationStores[];
  selectedStores?: string[];
  selectedTab?: string;
  pageFilterParam?: Partial<DashboardElementParam>;
  selectedDeviceInfo?: SelectedDeviceInfo;
  currentChartOrder?: string[];
  deviceList?: string[];
  previousPageId?: string;
  hourEnabled?: boolean;
  hourSelectorType?: HourSelectorType;
  pageCategory?: string;
  canManageApps?: boolean;
  report_identifier?: string;
  charts?: DashboardElement[];
  claims?: number[];
  multiHourSelector?: boolean;
  childMcGroups?: boolean;
}

export interface SelectedDeviceInfo {
  id: string;
  name: string;
  osId?: number;
  enrollmentDates?: {
    dateFrom: Date;
    dateTo: Date;
  };
  parentId?: string;
  parentName?: string;
  decomissionOn?: string;
}

/**
 * Legacy API contract for getting all groups by MC instance
 */
export interface McGroupInfo {
  Path: string;
  Name: string;
  GroupId: number;
}

export interface PageConfigWithCharts extends PageConfig {
  charts: DashboardElement[];
}

export interface FilterBarExpression {
  filterElements: FilterElement[];
}

export interface IDateFilterSelection {
  dateRange: IDateRange;
  dateFilterType: FilterDateSelectionType;
  hour?: string;
}

export interface IGroupFilterSelection {
  groupIds: number[];
}

export interface IStoreFilterSelection {
  stores: string[];
}

export interface PredefinedCharts {
  category: Category;
  charts: ChartOption[];
}

export interface ChartOption {
  chartId: string;
  isSelected: boolean;
  name: string;
  tooltip?: string;
}

export interface Category {
  name: string;
  icon: string;
  tooltip?: string;
}

export interface DeviceTabInfo {
  name: string;
  index: number;
  dateRangeTypes: FilterDateSelectionType[];
}

export const PageCategory = {
  APP: 'App',
  BATTERYSHIFT: 'Battery-Shift',
  DEVICE: 'Device',
  WATCHLIST: 'Watchlist',
  WEBAPP: 'WebApp',
  UTILIZATION: 'Util',
};

export enum HourSelectorType {
  SELECTBOX = 'Selectbox',
  CHECKBOX = 'Checkbox',
}
